import {
  SET_HEATMAP_METRIC,
  SET_HEATMAP_DATE_RANGE,
  SET_HEATMAP_HIGH_COLOR,
  SET_HEATMAP_LOW_COLOR,
  RESET_HEATMAP_STATE,
  HeatMapDateRangeState,
  SetHeatMapMetricAction,
  SetHeatMapDateRangeAction,
  SetHeatMapHighColorAction,
  SetHeatMapLowColorAction,
  ResetHeatMapStateAction,
} from "./HeatMapTypes";

export const setHeatMapMetric = (
  metric: string,
): SetHeatMapMetricAction => ({
  type: SET_HEATMAP_METRIC,
  payload: { metric },
});

export const setHeatMapDateRange = (
  dateRange: HeatMapDateRangeState,
): SetHeatMapDateRangeAction => ({
  type: SET_HEATMAP_DATE_RANGE,
  payload: dateRange,
});

export const setHeatMapHighColor = (
  color: string,
): SetHeatMapHighColorAction => ({
  type: SET_HEATMAP_HIGH_COLOR,
  payload: { color },
});

export const setHeatMapLowColor = (
  color: string,
): SetHeatMapLowColorAction => ({
  type: SET_HEATMAP_LOW_COLOR,
  payload: { color },
});

export const resetHeatMapState = (): ResetHeatMapStateAction => ({
  type: RESET_HEATMAP_STATE,
});
